import { render, staticRenderFns } from "./user_flow_base.vue?vue&type=template&id=9fb08bfe&scoped=true"
import script from "./user_flow_base.vue?vue&type=script&lang=js"
export * from "./user_flow_base.vue?vue&type=script&lang=js"
import style0 from "./user_flow_base.vue?vue&type=style&index=0&id=9fb08bfe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb08bfe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VBtnToggle,VList,VListItem,VMenu})
